import React from 'react'
import { Header, SearchBar, VideoList, VideoDetails } from './components/index'
import youtube from './api/youtube'

import { Grid, Typography } from '@material-ui/core'
import styled from 'styled-components'

const PreviewStyles = styled.div`
  display: flex;
`
class App extends React.Component {
  state = {
    videos: [],
    selectedVideo: null,
  }

  componentDidMount () {
    this.handleSubmit('iguazu falls')
  }

  onVideoSelect = (video) => {
    this.setState({ selectedVideo: video})
  }

  handleSubmit = async (searchTerm) => {
    const response = await youtube.get('search', { 
      params: {
        part: 'snippet',
        maxResults: 4,
        key: 'AIzaSyCztjNCRnbKdDLDoxhk9EOWeJPyjrt3opk',
        q: searchTerm,
      }
    })
    this.setState({ videos: response.data.items, selectedVideo: response.data.items[0] })
  }
  render () {
    const { selectedVideo, videos } = this.state
    return (
      <Grid justify='center' container spacing={0}>
        <Grid item xs={12}>
            <Grid item xs={12}>
              <Header />
              <Grid item xs={12}>
                <SearchBar onFormSubmit={this.handleSubmit} />
              </Grid>
            </Grid>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <VideoDetails videos={selectedVideo} />
            </Grid>
            <Grid item xs={12}>
              <Typography variant='h4' style={{ padding: '70px 0 35px 0', textAlign: 'center', marginBottom: '25px' }}><b>Or maybe you would prefer one of these...</b></Typography>
              <PreviewStyles>
                <VideoList videos={videos} onVideoSelect={this.onVideoSelect}/>
              </PreviewStyles>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

export default App
